import { parseTemplate } from 'url-template';
import { InternalAxiosRequestConfig } from 'axios';

interface InternalAxiosRequestConfigWithMock
  extends InternalAxiosRequestConfig {
  mock?: boolean;
}

export function mockInterceptor(config: InternalAxiosRequestConfigWithMock) {
  if (config.mock) {
    const { url = '', urlParams = {} } = config;

    config.url = new URL(parseTemplate(url).expand(urlParams)).pathname;
    delete config.mock;
  }

  return config;
}
